module.exports = __webpack_public_path__ + "static/img/mobile-about.f5adad6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/mobile-about.svg
// module id = 1157
// module chunks = 173